import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import VersionEdit          from "./VersionEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Version List
 * @returns {React.ReactElement}
 */
function VersionList() {
    const { fetch, load } = useList("version");

    const data = Store.useState("version");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("version");


    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "versionID", elemID, "version");

    return <Main>
        <Header message="VERSIONS_NAME" icon="version">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="VERSIONS_NONE_AVAILABLE"
                isLoading={loading}
            >
                <TableHead>
                    <TableHeader field="version"     message="VERSIONS_SINGULAR"      isTitle />
                    <TableHeader field="environment" message="VERSIONS_ENVIRONMENT"   />
                    <TableHeader field="createdTime" message="GENERAL_CREATED_AT_FEM" maxWidth="100"  />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.versionID} elemID={elem.versionID}>
                        <TableCell message={elem.version}         />
                        <TableCell message={elem.environmentName} />
                        <TableCell message={elem.createdDate}     />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="VERSIONS_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="VERSIONS_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <VersionEdit
            open={action.isVCE}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="VERSIONS_DELETE_TITLE"
            message="VERSIONS_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default VersionList;
